// src/pages/ResourcesPage.js
import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import MapComponent from '../components/Map'; // Import the new Map component

const ResourcesPage = () => {
  return (
    <div>
      <PublicNavbar />
      {/* The MapComponent will render the full-screen map */}
      <MapComponent />
    </div>
  );
};

export default ResourcesPage;
